import { type HoruzProtocolChulakServiceSessionGuardTags } from '@ver.id/libs.internal.horuz';
import { type DeviceOs } from './platform';
import { installLinksMap } from '../data/installLinks';

/** The link that opens the identity app on this phone, if it has one. */
export function appLinkFor(
  tags: HoruzProtocolChulakServiceSessionGuardTags,
  os: DeviceOs,
): string | undefined {
  if (!tags.app) return undefined;
  return os === 'ios'
    ? tags.app.universalAppLink || tags.app.deepAppLink
    : tags.app.intentAppLink || tags.app.deepAppLink;
}

/** The app's store listing for this phone, if we know it. */
export function storeLinkFor(
  appName: string,
  os: DeviceOs,
): string | undefined {
  const links = installLinksMap[appName];
  if (os === 'ios') return links?.apple;
  if (os === 'android') return links?.android;
  return undefined;
}

/** Ronan's install page for the app, which forwards a phone to its store. */
export function installPageUrl(appName: string): string {
  return `${window.location.origin}/?app=${encodeURIComponent(appName)}`;
}

/**
 * Opens the app from inside the iframe in a new browsing context, so the
 * website's page stays as it is when the app is not installed.
 */
export function openLink(link: string) {
  window.open(link, '_blank', 'noopener');
}
